import MenuBuilder from './MobileMenu/MenuBuilder';
//	Core
import Mmenu from 'mmenu-js/dist/core/oncanvas/mmenu.oncanvas';
//	Core add-ons
import offcanvas from 'mmenu-js/dist/core/offcanvas/mmenu.offcanvas';
import screenReader from 'mmenu-js/dist/core/screenreader/mmenu.screenreader';
import scrollBugFix from 'mmenu-js/dist/core/scrollbugfix/mmenu.scrollbugfix';
//	Add-ons
import autoHeight from 'mmenu-js/dist/addons/autoheight/mmenu.autoheight';
import counters from 'mmenu-js/dist/addons/counters/mmenu.counters';
import iconPanels from 'mmenu-js/dist/addons/iconpanels/mmenu.iconpanels';
import keyboardNavigation from 'mmenu-js/dist/addons/keyboardnavigation/mmenu.keyboardnavigation';
import navbars from 'mmenu-js/dist/addons/navbars/mmenu.navbars';
import searchfield from 'mmenu-js/dist/addons/searchfield/mmenu.searchfield';

const DOMReady = function(callback) {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
    return;
  }
  document.addEventListener('DOMContentLoaded', callback());
};

function replaceMMenuSearchfieldWithSearchForm() {
  const mmSearchfield = document.querySelector('.mm-searchfield__input');
  mmSearchfield.innerHTML = '';

  const quicksearch = document.querySelector('form.quicksearch').cloneNode(true);
  quicksearch.setAttribute('class', 'w-100');

  const quicksearchInput = quicksearch.querySelector('.form-control');
  quicksearchInput.setAttribute('class', '');

  mmSearchfield.append(quicksearch);
}

Mmenu.addons = {
  //	Core add-ons
  offcanvas,
  screenReader,
  scrollBugFix,

  //	Add-ons
  autoHeight,
  counters,
  iconPanels,
  keyboardNavigation,
  navbars,
  searchfield
};

const menuBuilder = new MenuBuilder();

//	Wrappers
Mmenu.wrappers = {};

function buildFeedbackAndContactButton() {
  const feedbackLink = document.querySelector('a.feedback-link');
  const contactLink = document.querySelector('a.contact-link');
  var content = '<ul style="list-style: none; margin: 0; padding: 0">';

  if (!feedbackLink && !contactLink) {
    return {};
  }

  if (feedbackLink) {
    const feedbackUrl = feedbackLink.getAttribute('href');
    var feedbackLabel = feedbackLink.querySelector('.feedback-text').textContent

    if (feedbackLink.querySelector('[data-mobile-label]')) {
      feedbackLabel = feedbackLink.querySelector('[data-mobile-label]').getAttribute('data-mobile-label')
    }

    content += '<li class="nav-item">' +
      '<a href="' + feedbackUrl + '" class="nav-link" target="_blank">' +
      '<i aria-hidden="true" class="fas-comment-alt-smile"></i>' + feedbackLabel + '' +
      '</a>' +
      '</li>';
  }

  if (contactLink) {
    const contactUrl = contactLink.getAttribute('href');
    var contactLabel = contactLink.querySelector('.contact-text').textContent

    if (contactLink.querySelector('[data-mobile-label]')) {
      contactLabel = contactLink.querySelector('[data-mobile-label]').getAttribute('data-mobile-label')
    }

    content += '<li class="nav-item">' +
      '<a href="' + contactUrl + '" class="nav-link" target="_blank">' +
      '<i aria-hidden="true" class="fas-phone"></i>' + contactLabel + '' +
      '</a>' +
      '</li>';
  }

  content += '</ul>';

  return {
    'position': 'bottom',
    'content': [content]
  }
}

function getHtmlOfFirstElementWithClass(className) {
  const elements = document.getElementsByClassName(className);
  if (!elements.length) {
    return '';
  }
  return elements[0].outerHTML;
}

//  Export module
export default Mmenu;
let initMenu = (function() {
  // Query all relevant elements
  let parentEl = document.getElementById('navbarMobile');
  // Splice desktop nav into sub navs
  const allInstitutions = getHtmlOfFirstElementWithClass('navbar-quick-all-institutions');
  const uniFl = getHtmlOfFirstElementWithClass('navbar-quick-unifl');
  const hsFl = getHtmlOfFirstElementWithClass('navbar-quick-hsfl');
  const easyRead = getHtmlOfFirstElementWithClass('navbar-quick-easy-read');
  const applyNow = getHtmlOfFirstElementWithClass('navbar-quick-apply-now');

  let languageNav = getHtmlOfFirstElementWithClass('navbar-quick-language-navigation');
  languageNav = languageNav.replaceAll('"navbarLanguage"', '"navbarLanguageMobile"')

  let quicklinks = getHtmlOfFirstElementWithClass('navbar-quick-quicklinks');
  quicklinks = quicklinks.replaceAll('"quicklinks"', '"quicklinksMobile"')

  // Create nav template for mmenu
  parentEl.append(menuBuilder.buildMobileMenu());

  const prependNavbars = [];
  prependNavbars.push(buildFeedbackAndContactButton())

  const prependApplyNow = [];
  if (applyNow) {
    prependApplyNow.push({
      'position': 'bottom',
      'content': [
        '<ul style="list-style: none; margin: 0; padding: 0" class="bg-secondary">'
        + applyNow +
        '</ul>'
      ]
    })
  }

  let secondTitle = null;
  const mobileNavbarElements = document.querySelector('#navbarMobile > ul');
  if (mobileNavbarElements && mobileNavbarElements.childElementCount === 1) {
    const titleTextElement = mobileNavbarElements.children[0].querySelector('span, a');
    const navigationElement = mobileNavbarElements.querySelector('ul');

    if (titleTextElement && navigationElement) {
      titleTextElement.dataset.mobileNavLabel = titleTextElement.innerText;
      titleTextElement.title = titleTextElement.innerText;
      secondTitle = titleTextElement.outerHTML;
      mobileNavbarElements.replaceWith(navigationElement);
    }
  }

  const menu = new Mmenu(
    '#navbarMobile',
    {
      extensions: [
        'pagedim-black',
        'position-right',
      ],
      counters: true,
      iconPanels: {
        add: true,
        visible: 2
      },
      navbar: {
        add: secondTitle !== null,
        title: secondTitle,
      },
      navbars: [
        ...prependNavbars,
        ...prependApplyNow,
        {
          'position': 'bottom',
          'content': [
            '<ul style="list-style: none; margin: 0; padding: 0">' + allInstitutions + easyRead + uniFl + hsFl + '</ul>'
          ],
        },
        {
          'position': 'top',
          'content': [
            'searchfield'
          ]
        },
        {
          'position': 'top',
          'content': [
            '<ul style="list-style: none; margin: 0; padding: 0">' + languageNav + quicklinks + '</ul>'
          ],
        },
        {
          'position': 'top',
          'content': [
            '<span class="mm-navbar__title">' + menuBuilder.createHomepageLinkWrapper().innerHTML + '</span>'
          ],
        }
      ],
    },
    {
      classNames: {
        selected: 'active'
      },
    }
  );

  const api = menu.API;

  document.querySelector('#mainNavToggle')
    .addEventListener(
      'click', (evnt) => {
        evnt.preventDefault();
        api.open();
      },
    );

  replaceMMenuSearchfieldWithSearchForm();
});

DOMReady(() => {
  initMenu();

  // Move the skiplinks back to be the first elements in the page.
  const skiplinkContent = document.querySelector('a[href="#content-main-container"]');
  const skiplinkMainNav = document.querySelector('a[href="#main-navigation"]');

  if (skiplinkMainNav) {
    document.body.prepend(skiplinkMainNav);
  }
  if (skiplinkContent) {
    document.body.prepend(skiplinkContent);
  }
});
